import { useLocation } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { logixPanelRootURL } from 'api/config';
import { usePersistStore, useStore } from 'store';
import { handleLogoutRedirect } from 'utils/common';
import { OldPagesIframe, IframeWrapper } from './styled';

type IframeMessage = {
  action?: string;
};

const OldpageShower = ():JSX.Element => {
  const location = useLocation();
  const { lang } = usePersistStore();
  const changeAuth = useStore((state) => state.changeAuth);
  const [maximize, setMaximize] = useState<boolean>(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const handleMessage = (event: MessageEvent): void => {
      const iframeWindow = iframeRef.current?.contentWindow;
      const oldSiteOrigin = new URL(logixPanelRootURL as string).origin;
      if (event.origin !== oldSiteOrigin || event.source !== iframeWindow) return;
      if (typeof event.data !== 'object' || event.data === null) return;

      const message = event.data as IframeMessage;
      if (message.action === 'maximize') {
        setMaximize((prevMaximize) => !prevMaximize);
      }
      if (message.action === 'logout') {
        localStorage.removeItem('jwt-token');
        changeAuth(false);
        handleLogoutRedirect(lang);
      }
    };
    window.addEventListener('message', handleMessage);
    return () => {
      setMaximize(false);
      window.removeEventListener('message', handleMessage);
    };
  }, [changeAuth, lang]);

  useEffect(() => {
    setMaximize(false);
  }, [location]);

  const iframeLangUrl = `${logixPanelRootURL}/${lang}${(location.pathname + location.search)}`;

  const iframe = (
    <OldPagesIframe
      aria-label="iframe for the old version pages"
      key={location.pathname}
      ref={iframeRef}
      src={iframeLangUrl}
      maximize={maximize}
    />
  );
  /*
    have to replace a new iframe everytime the src change
    otherwise clicking previous page button will just shows
    the previous iframe of url that was pushed to iframe,
    instead of going to the previous page.
  */
  return <IframeWrapper>{iframe}</IframeWrapper>;
};

export default OldpageShower;
